export const Fade = {

  fadeIn(el: HTMLElement, duration = 600): void {
    el.style.opacity = '0'
    el.style.display = 'block'
    el.style.transition = `opacity ${duration}ms ease`
    requestAnimationFrame(() => {
      el.style.opacity = '1'
    })
  },

  fadeOut(el: HTMLElement, duration = 600): void {
    el.style.transition = `opacity ${duration}ms ease`
    el.style.opacity = '0'
    setTimeout(() => {
      el.style.display = 'none'
    }, duration)
  },

  // optional helper for delayed fade
  fadeInWithDelay(el: HTMLElement, delay = 0, duration = 600) {
    setTimeout(() => this.fadeIn(el, duration), delay)
  },

  fadeOutWithDelay(el: HTMLElement, delay = 0, duration = 600) {
    setTimeout(() => this.fadeOut(el, duration), delay)
  }
}
